import { useState } from "react";
import CountryCreateModal from "../pages/Modals/CountryCreateModal";
import CurrencyCreateModal from "../pages/Modals/CurrencyCreateModal";
import RoleCreateModal from "../pages/Modals/RoleCreateModal";
import CustomerCreateModal from "../pages/Modals/CustomerCreateModal";
import VendorCreateModal from "../pages/Modals/VendorCreateModal";
import YardCreateModal from "../pages/Modals/YardCreateModal";
import LotCreateModal from "../pages/Modals/LotCreateModal";
import StockCategoryCreateModal from "../pages/Modals/StockCategoryCreateModal";
import ShippingLineCreateModal from "../pages/Modals/ShippingLineCreateModal";
import ExpenseCreateModal from "../pages/Modals/ExpenseCreateModal";
import ExpenseCategoryCreateModal from "../pages/Modals/ExpenseCategoryCreateModal";
import CompanyCreateModal from "../pages/Modals/CompanyCreateModal";

export const useMasterModals = (onSuccessMap = {}) => {
  const [activeModal, setActiveModal] = useState(null);

  const openModal = (modalName) => setActiveModal(modalName);
  const closeModal = () => setActiveModal(null);

  const renderModals = () => {
    return (
      <>
        <CountryCreateModal
          isOpen={activeModal === "country"}
          onClose={closeModal}
          onSuccess={onSuccessMap.country}
        />
        <CurrencyCreateModal
          isOpen={activeModal === "currency"}
          onClose={closeModal}
          onSuccess={onSuccessMap.currency}
        />
        <RoleCreateModal
          isOpen={activeModal === "role"}
          onClose={closeModal}
          onSuccess={onSuccessMap.role}
        />
        <CustomerCreateModal
          isOpen={activeModal === "customer"}
          onClose={closeModal}
          onSuccess={onSuccessMap.customer}
        />
        <VendorCreateModal
          isOpen={activeModal === "vendor"}
          onClose={closeModal}
          onSuccess={onSuccessMap.vendor}
        />
        <YardCreateModal
          isOpen={activeModal === "yard"}
          onClose={closeModal}
          onSuccess={onSuccessMap.yard}
        />
        <LotCreateModal
          isOpen={activeModal === "lot"}
          onClose={closeModal}
          onSuccess={onSuccessMap.lot}
        />
        <StockCategoryCreateModal
          isOpen={activeModal === "stockCategory"}
          onClose={closeModal}
          onSuccess={onSuccessMap.stockCategory}
        />
        <ShippingLineCreateModal
          isOpen={activeModal === "shippingLine"}
          onClose={closeModal}
          onSuccess={onSuccessMap.shippingLine}
        />
        <ExpenseCreateModal
          isOpen={activeModal === "expense"}
          onClose={closeModal}
          onSuccess={onSuccessMap.expense}
        />
        <ExpenseCategoryCreateModal
          isOpen={activeModal === "expenseCategory"}
          onClose={closeModal}
          onSuccess={onSuccessMap.expenseCategory}
        />
        <CompanyCreateModal
          isOpen={activeModal === "company"}
          onClose={closeModal}
          onSuccess={onSuccessMap.company}
        />
      </>
    );
  };

  return {
    openModal,
    closeModal,
    renderModals,
  };
};
